import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasUploaderComponent } from './gas-uploader.component';
import { GasUploaderDirectiveModule } from './../../utils/gas-uploader-directive/gas-uploader-directive.module';
import { GasCardModule } from './../../layout/gas-card/gas-card.module';
import { GasProgressBarModule } from './../gas-progress-bar/progress-bar.module';
import { GasSpinnerModule } from './../gas-spinner/gas-spinner.module';


const COMPONENTS = [
  GasUploaderComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasUploaderDirectiveModule,
    GasCardModule,
    GasProgressBarModule,
    GasSpinnerModule,
  ],
})
export class GasUploaderModule { }
